// csrf_token is the one auth cookie that's readable (not HttpOnly) - the backend
// expects it echoed back as X-CSRF-Token on every mutating (POST/PUT/PATCH/DELETE)
// request. It rotates on every login/client-selection/refresh, so always re-read
// it right before building the header rather than caching the value.
export function getCsrfToken() {
  if (typeof document === 'undefined') {
    return null
  }
  const match = document.cookie.match(/(?:^|; )csrf_token=([^;]*)/)
  return match ? decodeURIComponent(match[1]) : null
}